import { ref, reactive } from "@vue/composition-api";

export const selectedGuids = ref([]);
export const deletePlaylist = reactive({
  showDialog: false,
  playlistId: ""
});
export const showRemoveFromPlaylistDialog = ref(false);
